var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('v-footer',{staticClass:"font-weight-medium",attrs:{"inset":"","padless":"","app":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © 2020 - PassDelivery.Web - Privacy ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }